import { useNavigate } from '@change-corgi/core-react/router';

import { usePromoteFormData } from '../../../formContext/formData';

import { useSetReceiptCookie } from './useSetReceiptCookie';

export function useNavigateToMembershipThankYouPage(): (membershipAmount: number) => void {
	const setReceiptCookie = useSetReceiptCookie();
	const navigate = useNavigate();

	const { membershipProgram } = usePromoteFormData();

	return function navigateToMembershipThankYouPage(membershipAmount: number): void {
		setReceiptCookie(membershipAmount);
		navigate(
			`/s/${
				(membershipProgram?.slug as string) || (membershipProgram?.id as string)
			}/post_promote_thank_you?source_location=post_promotion`,
		);
	};
}
